import React, { useContext } from "react";
import { Card, message, Typography } from "antd";
import { DeleteButtonComponent } from "../../../Shared/Components/Buttons/DeleteButtonComponent";
import { AccountService } from "../Services/AccountService";
import { ApiErrorResponse } from "../../../Shared/Models/ApiErrorResponse";
import { ConfirmationModalComponent } from "../../../Shared/Components/Validation/ConfirmationModalComponent";
import { SignalRProgressComponent } from "../../../Shared/Components/SignalRProgress/SignalRProgressComponent";
import { AppContext } from "../../../Configuration/Context/AppContext";

const ResetAccountComponent = () => {
  const { userGroupPrefix } = useContext(AppContext);

  return (
    <Card title="Reset Account">
      <Typography.Paragraph>
        This action will permanently delete all your caves and related account
        data. This action is irreversible.
      </Typography.Paragraph>
      <ConfirmationModalComponent
        autoClose={false}
        title={`Reset Account`}
        modalMessage={
          <>
            Are you positive you want to delete <b>ALL</b> cave data?! This is
            an irreversible action!
          </>
        }
        onConfirm={async () => {
          try {
            await AccountService.ResetAccount();
          } catch (e) {
            const error = e as ApiErrorResponse;
            message.error(error.message);
          }
        }}
        okText="Yes"
        cancelText="No"
        confirmationWord={"DELETE EVERYTHING"}
        onOkClickRender={
          <>
            <Card>
              <SignalRProgressComponent
                groupName={
                  userGroupPrefix ? `${userGroupPrefix}-DeleteAllCaves` : null
                }
                isLoading={true}
              ></SignalRProgressComponent>
            </Card>
          </>
        }
      >
        Delete
      </ConfirmationModalComponent>
    </Card>
  );
};

export { ResetAccountComponent };
